import React, { useState } from 'react';

export interface IRoutedBreadcrumbContextProps {
  globalLookup: Map<string, string>;
  localLookup: Map<string, string>;
  setGlobalLookup: (lookup: Map<string, string>) => void;
  setLocalLookup: (
    key?: string,
    value?: string,
    lookup?: Map<string, string> | null | undefined
  ) => void;
}

export const routedBreadcrumbContextDefaults: IRoutedBreadcrumbContextProps = {
  globalLookup: new Map<string, string>(),
  localLookup: new Map<string, string>(),
  setGlobalLookup: () => null,
  setLocalLookup: () => null,
};

export const routedBreadcrumbStateDefaults = {
  globalLookup: '',
  localLookup: null,
};

export const RoutedBreadcrumbContext =
  React.createContext<IRoutedBreadcrumbContextProps>(
    routedBreadcrumbContextDefaults
  );

export default function RoutedBreadcrumbContextProvider({
  children,
}: React.PropsWithChildren<unknown>) {
  const defaultMap = new Map<string, string>();
  defaultMap.set('localizationTable', 'Localization Table');
  const [globalLookup, setGobalLookupState] = useState(
    new Map<string, string>(defaultMap)
  );
  const [localLookup, setLocalLookupState] = useState(
    new Map<string, string>()
  );

  const setGlobalLookup = (lookup: Map<string, string> | null | undefined) => {
    if (lookup) {
      lookup = new Map<string, string>([...lookup, ...defaultMap]);
      setGobalLookupState(lookup);
    }
  };

  const setLocalLookup = (
    key?: string,
    value?: string,
    lookup?: Map<string, string> | null | undefined
  ) => {
    if (lookup) {
      const routeDisplayTable = new Map<string, string>();
      let toUpdate = false;
      lookup.forEach((val, key) => {
        if (!localLookup.get(key) || localLookup.get(key) !== val) {
          toUpdate = true;
        } else {
          toUpdate = toUpdate || false;
        }
      });
      if (toUpdate) {
        lookup.forEach((val, key) => {
          routeDisplayTable.set(key, val);
        });

        setLocalLookupState(routeDisplayTable);
      }
    } else if (key && value) {
      if (!localLookup.get(key) || localLookup.get(key) !== value) {
        const routeDisplayTable = new Map<string, string>();
        routeDisplayTable.set(key, value);
        setLocalLookupState(routeDisplayTable);
      }
    }
  };
  return (
    <RoutedBreadcrumbContext.Provider
      value={{
        globalLookup,
        localLookup,

        setGlobalLookup: (lookup: Map<string, string> | null | undefined) =>
          setGlobalLookup(lookup),

        setLocalLookup: (
          key?: string,
          value?: string,
          lookup?: Map<string, string> | null | undefined
        ) => setLocalLookup(key, value, lookup),
      }}>
      {children}
    </RoutedBreadcrumbContext.Provider>
  );
}
